import React from 'react';

const UnAuthorized = () => {
  return (
    <div>401</div>
  );
}
 
export default UnAuthorized;
